// @generated by protoc-gen-es v1.10.0
// @generated from file penumbra/core/component/dex/v1/dex.proto (package penumbra.core.component.dex.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Nullifier } from "../../sct/v1/sct_pb.js";
import { Fee } from "../../fee/v1/fee_pb.js";
import { StateCommitment } from "../../../../crypto/tct/v1/tct_pb.js";
import { Amount } from "../../../num/v1/num_pb.js";
import { AssetId, BalanceCommitment, Metadata, Value, ValueView } from "../../../asset/v1/asset_pb.js";
import { Address } from "../../../keys/v1/keys_pb.js";
import { TransactionId } from "../../../txhash/v1/txhash_pb.js";
import { NoteView } from "../../shielded_pool/v1/shielded_pool_pb.js";

/**
 * A Penumbra ZK swap proof.
 *
 * @generated from message penumbra.core.component.dex.v1.ZKSwapProof
 */
export const ZKSwapProof = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.ZKSwapProof",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * A Penumbra ZK swap claim proof.
 *
 * @generated from message penumbra.core.component.dex.v1.ZKSwapClaimProof
 */
export const ZKSwapClaimProof = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.ZKSwapClaimProof",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * A transaction action that submits a swap to the dex.
 *
 * @generated from message penumbra.core.component.dex.v1.Swap
 */
export const Swap = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.Swap",
  () => [
    { no: 1, name: "proof", kind: "message", T: ZKSwapProof },
    { no: 4, name: "body", kind: "message", T: SwapBody },
  ],
);

/**
 * A transaction action that obtains assets previously confirmed
 * via a Swap transaction. Does not include a spend authorization
 * signature, as it is only capable of consuming the NFT from a
 * Swap transaction.
 *
 * @generated from message penumbra.core.component.dex.v1.SwapClaim
 */
export const SwapClaim = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SwapClaim",
  () => [
    { no: 1, name: "proof", kind: "message", T: ZKSwapClaimProof },
    { no: 2, name: "body", kind: "message", T: SwapClaimBody },
    { no: 7, name: "epoch_duration", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * Encapsulates the authorized fields of the SwapClaim action, used in signing.
 *
 * @generated from message penumbra.core.component.dex.v1.SwapClaimBody
 */
export const SwapClaimBody = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SwapClaimBody",
  () => [
    { no: 1, name: "nullifier", kind: "message", T: Nullifier },
    { no: 2, name: "fee", kind: "message", T: Fee },
    { no: 3, name: "output_1_commitment", kind: "message", T: StateCommitment },
    { no: 4, name: "output_2_commitment", kind: "message", T: StateCommitment },
    { no: 6, name: "output_data", kind: "message", T: BatchSwapOutputData },
  ],
);

/**
 * The authorized data of a Swap transaction.
 *
 * @generated from message penumbra.core.component.dex.v1.SwapBody
 */
export const SwapBody = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SwapBody",
  () => [
    { no: 1, name: "trading_pair", kind: "message", T: TradingPair },
    { no: 2, name: "delta_1_i", kind: "message", T: Amount },
    { no: 3, name: "delta_2_i", kind: "message", T: Amount },
    { no: 4, name: "fee_commitment", kind: "message", T: BalanceCommitment },
    { no: 5, name: "payload", kind: "message", T: SwapPayload },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.SwapPayload
 */
export const SwapPayload = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SwapPayload",
  () => [
    { no: 1, name: "commitment", kind: "message", T: StateCommitment },
    { no: 2, name: "encrypted_swap", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.SwapPlaintext
 */
export const SwapPlaintext = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SwapPlaintext",
  () => [
    { no: 1, name: "trading_pair", kind: "message", T: TradingPair },
    { no: 2, name: "delta_1_i", kind: "message", T: Amount },
    { no: 3, name: "delta_2_i", kind: "message", T: Amount },
    { no: 4, name: "claim_fee", kind: "message", T: Fee },
    { no: 5, name: "claim_address", kind: "message", T: Address },
    { no: 6, name: "rseed", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.SwapPlan
 */
export const SwapPlan = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SwapPlan",
  () => [
    { no: 1, name: "swap_plaintext", kind: "message", T: SwapPlaintext },
    { no: 2, name: "fee_blinding", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "proof_blinding_r", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 4, name: "proof_blinding_s", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.SwapClaimPlan
 */
export const SwapClaimPlan = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SwapClaimPlan",
  () => [
    { no: 1, name: "swap_plaintext", kind: "message", T: SwapPlaintext },
    { no: 2, name: "position", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "output_data", kind: "message", T: BatchSwapOutputData },
    { no: 4, name: "epoch_duration", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "proof_blinding_r", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 6, name: "proof_blinding_s", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.SwapView
 */
export const SwapView = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SwapView",
  () => [
    { no: 1, name: "visible", kind: "message", T: SwapView_Visible, oneof: "swap_view" },
    { no: 2, name: "opaque", kind: "message", T: SwapView_Opaque, oneof: "swap_view" },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.SwapView.Visible
 */
export const SwapView_Visible = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SwapView.Visible",
  () => [
    { no: 1, name: "swap", kind: "message", T: Swap },
    { no: 3, name: "swap_plaintext", kind: "message", T: SwapPlaintext },
    { no: 4, name: "claim_tx", kind: "message", T: TransactionId },
    { no: 20, name: "batch_swap_output_data", kind: "message", T: BatchSwapOutputData },
    { no: 30, name: "output_1", kind: "message", T: NoteView },
    { no: 31, name: "output_2", kind: "message", T: NoteView },
    { no: 40, name: "asset_1_metadata", kind: "message", T: Metadata },
    { no: 41, name: "asset_2_metadata", kind: "message", T: Metadata },
  ],
  {localName: "SwapView_Visible"},
);

/**
 * @generated from message penumbra.core.component.dex.v1.SwapView.Opaque
 */
export const SwapView_Opaque = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SwapView.Opaque",
  () => [
    { no: 1, name: "swap", kind: "message", T: Swap },
    { no: 20, name: "batch_swap_output_data", kind: "message", T: BatchSwapOutputData },
    { no: 30, name: "output_1_value", kind: "message", T: ValueView },
    { no: 31, name: "output_2_value", kind: "message", T: ValueView },
    { no: 40, name: "asset_1_metadata", kind: "message", T: Metadata },
    { no: 41, name: "asset_2_metadata", kind: "message", T: Metadata },
  ],
  {localName: "SwapView_Opaque"},
);

/**
 * @generated from message penumbra.core.component.dex.v1.SwapClaimView
 */
export const SwapClaimView = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SwapClaimView",
  () => [
    { no: 1, name: "visible", kind: "message", T: SwapClaimView_Visible, oneof: "swap_claim_view" },
    { no: 2, name: "opaque", kind: "message", T: SwapClaimView_Opaque, oneof: "swap_claim_view" },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.SwapClaimView.Visible
 */
export const SwapClaimView_Visible = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SwapClaimView.Visible",
  () => [
    { no: 1, name: "swap_claim", kind: "message", T: SwapClaim },
    { no: 2, name: "output_1", kind: "message", T: NoteView },
    { no: 3, name: "output_2", kind: "message", T: NoteView },
    { no: 4, name: "swap_tx", kind: "message", T: TransactionId },
  ],
  {localName: "SwapClaimView_Visible"},
);

/**
 * @generated from message penumbra.core.component.dex.v1.SwapClaimView.Opaque
 */
export const SwapClaimView_Opaque = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SwapClaimView.Opaque",
  () => [
    { no: 1, name: "swap_claim", kind: "message", T: SwapClaim },
  ],
  {localName: "SwapClaimView_Opaque"},
);

/**
 * Holds two asset IDs. Ordering doesn't reflect trading direction. Instead, we
 * require `asset_1 < asset_2` as field elements, to ensure a canonical
 * representation of an unordered pair.
 *
 * @generated from message penumbra.core.component.dex.v1.TradingPair
 */
export const TradingPair = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.TradingPair",
  () => [
    { no: 1, name: "asset_1", kind: "message", T: AssetId },
    { no: 2, name: "asset_2", kind: "message", T: AssetId },
  ],
);

/**
 * Encodes a trading pair starting from asset `start`
 * and ending on asset `end`.
 *
 * @generated from message penumbra.core.component.dex.v1.DirectedTradingPair
 */
export const DirectedTradingPair = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.DirectedTradingPair",
  () => [
    { no: 1, name: "start", kind: "message", T: AssetId },
    { no: 2, name: "end", kind: "message", T: AssetId },
  ],
);

/**
 * Records the result of a batch swap on-chain.
 *
 * Used as a public input to a swap claim proof, as it implies the effective
 * clearing price for the batch.
 *
 * @generated from message penumbra.core.component.dex.v1.BatchSwapOutputData
 */
export const BatchSwapOutputData = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.BatchSwapOutputData",
  () => [
    { no: 1, name: "delta_1", kind: "message", T: Amount },
    { no: 2, name: "delta_2", kind: "message", T: Amount },
    { no: 3, name: "lambda_1", kind: "message", T: Amount },
    { no: 4, name: "lambda_2", kind: "message", T: Amount },
    { no: 5, name: "unfilled_1", kind: "message", T: Amount },
    { no: 6, name: "unfilled_2", kind: "message", T: Amount },
    { no: 7, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 8, name: "trading_pair", kind: "message", T: TradingPair },
    { no: 9, name: "epoch_starting_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 10, name: "sct_position_prefix", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * The trading function for a specific pair.
 * For a pair (asset_1, asset_2), a trading function is defined by:
 * `phi(R) = p*R_1 + q*R_2` and `gamma = 1 - fee`.
 * The trading function is frequently referred to as "phi".
 *
 * @generated from message penumbra.core.component.dex.v1.TradingFunction
 */
export const TradingFunction = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.TradingFunction",
  () => [
    { no: 1, name: "component", kind: "message", T: BareTradingFunction },
    { no: 2, name: "pair", kind: "message", T: TradingPair },
  ],
);

/**
 * The minimum amount of data describing a trading function.
 *
 * This implicitly treats the trading function as being between assets 1 and 2,
 * without specifying what those assets are, to avoid duplicating data (each
 * asset ID alone is twice the size of the trading function).
 *
 * @generated from message penumbra.core.component.dex.v1.BareTradingFunction
 */
export const BareTradingFunction = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.BareTradingFunction",
  () => [
    { no: 1, name: "fee", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "p", kind: "message", T: Amount },
    { no: 3, name: "q", kind: "message", T: Amount },
  ],
);

/**
 * The reserves of a position.
 *
 * Like a position, this implicitly treats the trading function as being
 * between assets 1 and 2, without specifying what those assets are, to avoid
 * duplicating data (each asset ID alone is four times the size of the
 * reserves).
 *
 * @generated from message penumbra.core.component.dex.v1.Reserves
 */
export const Reserves = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.Reserves",
  () => [
    { no: 1, name: "r1", kind: "message", T: Amount },
    { no: 2, name: "r2", kind: "message", T: Amount },
  ],
);

/**
 * Data identifying a position.
 *
 * @generated from message penumbra.core.component.dex.v1.Position
 */
export const Position = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.Position",
  () => [
    { no: 1, name: "phi", kind: "message", T: TradingFunction },
    { no: 2, name: "nonce", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "state", kind: "message", T: PositionState },
    { no: 4, name: "reserves", kind: "message", T: Reserves },
    { no: 5, name: "close_on_fill", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * A hash of a `Position`.
 *
 * @generated from message penumbra.core.component.dex.v1.PositionId
 */
export const PositionId = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.PositionId",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "alt_bech32m", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * The state of a position.
 *
 * @generated from message penumbra.core.component.dex.v1.PositionState
 */
export const PositionState = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.PositionState",
  () => [
    { no: 1, name: "state", kind: "enum", T: proto3.getEnumType(PositionState_PositionStateEnum) },
    { no: 2, name: "sequence", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from enum penumbra.core.component.dex.v1.PositionState.PositionStateEnum
 */
export const PositionState_PositionStateEnum = /*@__PURE__*/ proto3.makeEnum(
  "penumbra.core.component.dex.v1.PositionState.PositionStateEnum",
  [
    {no: 0, name: "POSITION_STATE_ENUM_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "POSITION_STATE_ENUM_OPENED", localName: "OPENED"},
    {no: 2, name: "POSITION_STATE_ENUM_CLOSED", localName: "CLOSED"},
    {no: 3, name: "POSITION_STATE_ENUM_WITHDRAWN", localName: "WITHDRAWN"},
    {no: 4, name: "POSITION_STATE_ENUM_CLAIMED", localName: "CLAIMED"},
  ],
);

/**
 * An LPNFT tracking both ownership and state of a position.
 *
 * Tracking the state as part of the LPNFT means that all LP-related actions can
 * be authorized by spending funds: a state transition (e.g., closing a
 * position) is modeled as spending an "open position LPNFT" and minting a
 * "closed position LPNFT" for the same (globally unique) position ID.
 *
 * This means that the LP mechanics can be agnostic to the mechanism used to
 * record custody and spend authorization.  For instance, they can be recorded
 * in the shielded pool, where custody is based on off-chain keys, or they could
 * be recorded in a programmatic on-chain account (in the future, e.g., to
 * support interchain accounts).  This also means that LP-related actions don't
 * require any cryptographic implementation (proofs, signatures, etc), other
 * than hooking into the value commitment mechanism used for transaction
 * balances.
 *
 * @generated from message penumbra.core.component.dex.v1.LpNft
 */
export const LpNft = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.LpNft",
  () => [
    { no: 1, name: "position_id", kind: "message", T: PositionId },
    { no: 2, name: "state", kind: "message", T: PositionState },
  ],
);

/**
 * A transaction action that opens a new position.
 *
 * This action's contribution to the transaction's value balance is to consume
 * the initial reserves and contribute an opened position NFT.
 *
 * @generated from message penumbra.core.component.dex.v1.PositionOpen
 */
export const PositionOpen = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.PositionOpen",
  () => [
    { no: 1, name: "position", kind: "message", T: Position },
  ],
);

/**
 * A transaction action that closes a position.
 *
 * This action's contribution to the transaction's value balance is to consume
 * an opened position NFT and contribute a closed position NFT.
 *
 * Closing a position does not immediately withdraw funds, because Penumbra
 * transactions (like any ZK transaction model) are early-binding: the prover
 * must know the state transition they prove knowledge of, and they cannot know
 * the final reserves with certainty until after the position has been deactivated.
 *
 * @generated from message penumbra.core.component.dex.v1.PositionClose
 */
export const PositionClose = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.PositionClose",
  () => [
    { no: 1, name: "position_id", kind: "message", T: PositionId },
  ],
);

/**
 * A transaction action that withdraws funds from a closed position.
 *
 * This action's contribution to the transaction's value balance is to consume a
 * closed position NFT and contribute a withdrawn position NFT, as well as all
 * of the funds that were in the position at the time of closing.
 *
 * @generated from message penumbra.core.component.dex.v1.PositionWithdraw
 */
export const PositionWithdraw = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.PositionWithdraw",
  () => [
    { no: 1, name: "position_id", kind: "message", T: PositionId },
    { no: 2, name: "reserves_commitment", kind: "message", T: BalanceCommitment },
    { no: 3, name: "sequence", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * Deprecated.
 *
 * @generated from message penumbra.core.component.dex.v1.PositionRewardClaim
 */
export const PositionRewardClaim = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.PositionRewardClaim",
  () => [
    { no: 1, name: "position_id", kind: "message", T: PositionId },
    { no: 2, name: "rewards_commitment", kind: "message", T: BalanceCommitment },
  ],
);

/**
 * Contains the entire execution of a particular swap.
 *
 * @generated from message penumbra.core.component.dex.v1.SwapExecution
 */
export const SwapExecution = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SwapExecution",
  () => [
    { no: 1, name: "traces", kind: "message", T: SwapExecution_Trace, repeated: true },
    { no: 2, name: "input", kind: "message", T: Value },
    { no: 3, name: "output", kind: "message", T: Value },
  ],
);

/**
 * Contains all individual steps consisting of a trade trace.
 *
 * @generated from message penumbra.core.component.dex.v1.SwapExecution.Trace
 */
export const SwapExecution_Trace = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SwapExecution.Trace",
  () => [
    { no: 1, name: "value", kind: "message", T: Value, repeated: true },
  ],
  {localName: "SwapExecution_Trace"},
);

/**
 * Contains private and public data for withdrawing funds from a closed position.
 *
 * @generated from message penumbra.core.component.dex.v1.PositionWithdrawPlan
 */
export const PositionWithdrawPlan = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.PositionWithdrawPlan",
  () => [
    { no: 1, name: "reserves", kind: "message", T: Reserves },
    { no: 2, name: "position_id", kind: "message", T: PositionId },
    { no: 3, name: "pair", kind: "message", T: TradingPair },
    { no: 4, name: "sequence", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "rewards", kind: "message", T: Value, repeated: true },
  ],
);

/**
 * Deprecated.
 *
 * @generated from message penumbra.core.component.dex.v1.PositionRewardClaimPlan
 */
export const PositionRewardClaimPlan = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.PositionRewardClaimPlan",
  () => [
    { no: 1, name: "reserves", kind: "message", T: Reserves },
  ],
);

/**
 * Requests batch swap data associated with a given height and trading pair from the view service.
 *
 * @generated from message penumbra.core.component.dex.v1.BatchSwapOutputDataRequest
 */
export const BatchSwapOutputDataRequest = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.BatchSwapOutputDataRequest",
  () => [
    { no: 2, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "trading_pair", kind: "message", T: TradingPair },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.BatchSwapOutputDataResponse
 */
export const BatchSwapOutputDataResponse = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.BatchSwapOutputDataResponse",
  () => [
    { no: 1, name: "data", kind: "message", T: BatchSwapOutputData },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.SwapExecutionRequest
 */
export const SwapExecutionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SwapExecutionRequest",
  () => [
    { no: 2, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "trading_pair", kind: "message", T: DirectedTradingPair },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.SwapExecutionResponse
 */
export const SwapExecutionResponse = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SwapExecutionResponse",
  () => [
    { no: 1, name: "swap_execution", kind: "message", T: SwapExecution },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.ArbExecutionRequest
 */
export const ArbExecutionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.ArbExecutionRequest",
  () => [
    { no: 2, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.ArbExecutionResponse
 */
export const ArbExecutionResponse = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.ArbExecutionResponse",
  () => [
    { no: 1, name: "swap_execution", kind: "message", T: SwapExecution },
    { no: 2, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.SwapExecutionsRequest
 */
export const SwapExecutionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SwapExecutionsRequest",
  () => [
    { no: 2, name: "start_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "end_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "trading_pair", kind: "message", T: DirectedTradingPair },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.SwapExecutionsResponse
 */
export const SwapExecutionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SwapExecutionsResponse",
  () => [
    { no: 1, name: "swap_execution", kind: "message", T: SwapExecution },
    { no: 2, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "trading_pair", kind: "message", T: DirectedTradingPair },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.ArbExecutionsRequest
 */
export const ArbExecutionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.ArbExecutionsRequest",
  () => [
    { no: 2, name: "start_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "end_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.ArbExecutionsResponse
 */
export const ArbExecutionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.ArbExecutionsResponse",
  () => [
    { no: 1, name: "swap_execution", kind: "message", T: SwapExecution },
    { no: 2, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.LiquidityPositionsRequest
 */
export const LiquidityPositionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.LiquidityPositionsRequest",
  () => [
    { no: 4, name: "include_closed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.LiquidityPositionsResponse
 */
export const LiquidityPositionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.LiquidityPositionsResponse",
  () => [
    { no: 1, name: "data", kind: "message", T: Position },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.LiquidityPositionByIdRequest
 */
export const LiquidityPositionByIdRequest = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.LiquidityPositionByIdRequest",
  () => [
    { no: 2, name: "position_id", kind: "message", T: PositionId },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.LiquidityPositionByIdResponse
 */
export const LiquidityPositionByIdResponse = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.LiquidityPositionByIdResponse",
  () => [
    { no: 1, name: "data", kind: "message", T: Position },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.LiquidityPositionsByIdRequest
 */
export const LiquidityPositionsByIdRequest = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.LiquidityPositionsByIdRequest",
  () => [
    { no: 2, name: "position_id", kind: "message", T: PositionId, repeated: true },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.LiquidityPositionsByIdResponse
 */
export const LiquidityPositionsByIdResponse = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.LiquidityPositionsByIdResponse",
  () => [
    { no: 1, name: "data", kind: "message", T: Position },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.LiquidityPositionsByPriceRequest
 */
export const LiquidityPositionsByPriceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.LiquidityPositionsByPriceRequest",
  () => [
    { no: 2, name: "trading_pair", kind: "message", T: DirectedTradingPair },
    { no: 5, name: "limit", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.LiquidityPositionsByPriceResponse
 */
export const LiquidityPositionsByPriceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.LiquidityPositionsByPriceResponse",
  () => [
    { no: 1, name: "data", kind: "message", T: Position },
    { no: 2, name: "id", kind: "message", T: PositionId },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.SpreadRequest
 */
export const SpreadRequest = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SpreadRequest",
  () => [
    { no: 2, name: "trading_pair", kind: "message", T: TradingPair },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.SpreadResponse
 */
export const SpreadResponse = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SpreadResponse",
  () => [
    { no: 1, name: "best_1_to_2_position", kind: "message", T: Position },
    { no: 2, name: "best_2_to_1_position", kind: "message", T: Position },
    { no: 3, name: "approx_effective_price_1_to_2", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "approx_effective_price_2_to_1", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.SimulateTradeRequest
 */
export const SimulateTradeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SimulateTradeRequest",
  () => [
    { no: 1, name: "input", kind: "message", T: Value },
    { no: 2, name: "output", kind: "message", T: AssetId },
    { no: 3, name: "routing", kind: "message", T: SimulateTradeRequest_Routing },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.SimulateTradeRequest.Routing
 */
export const SimulateTradeRequest_Routing = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SimulateTradeRequest.Routing",
  () => [
    { no: 1, name: "default", kind: "message", T: SimulateTradeRequest_Routing_Default, oneof: "setting" },
    { no: 2, name: "single_hop", kind: "message", T: SimulateTradeRequest_Routing_SingleHop, oneof: "setting" },
  ],
  {localName: "SimulateTradeRequest_Routing"},
);

/**
 * @generated from message penumbra.core.component.dex.v1.SimulateTradeRequest.Routing.SingleHop
 */
export const SimulateTradeRequest_Routing_SingleHop = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SimulateTradeRequest.Routing.SingleHop",
  [],
  {localName: "SimulateTradeRequest_Routing_SingleHop"},
);

/**
 * @generated from message penumbra.core.component.dex.v1.SimulateTradeRequest.Routing.Default
 */
export const SimulateTradeRequest_Routing_Default = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SimulateTradeRequest.Routing.Default",
  [],
  {localName: "SimulateTradeRequest_Routing_Default"},
);

/**
 * @generated from message penumbra.core.component.dex.v1.SimulateTradeResponse
 */
export const SimulateTradeResponse = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.SimulateTradeResponse",
  () => [
    { no: 1, name: "output", kind: "message", T: SwapExecution },
    { no: 2, name: "unfilled", kind: "message", T: Value },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.EventSwap
 */
export const EventSwap = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.EventSwap",
  () => [
    { no: 1, name: "trading_pair", kind: "message", T: TradingPair },
    { no: 2, name: "delta_1_i", kind: "message", T: Amount },
    { no: 3, name: "delta_2_i", kind: "message", T: Amount },
    { no: 4, name: "swap_commitment", kind: "message", T: StateCommitment },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.EventSwapClaim
 */
export const EventSwapClaim = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.EventSwapClaim",
  () => [
    { no: 1, name: "trading_pair", kind: "message", T: TradingPair },
    { no: 2, name: "output_1_commitment", kind: "message", T: StateCommitment },
    { no: 3, name: "output_2_commitment", kind: "message", T: StateCommitment },
    { no: 4, name: "nullifier", kind: "message", T: Nullifier },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.EventPositionOpen
 */
export const EventPositionOpen = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.EventPositionOpen",
  () => [
    { no: 1, name: "position_id", kind: "message", T: PositionId },
    { no: 2, name: "trading_pair", kind: "message", T: TradingPair },
    { no: 3, name: "reserves_1", kind: "message", T: Amount },
    { no: 4, name: "reserves_2", kind: "message", T: Amount },
    { no: 5, name: "trading_fee", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.EventPositionClose
 */
export const EventPositionClose = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.EventPositionClose",
  () => [
    { no: 1, name: "position_id", kind: "message", T: PositionId },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.EventQueuePositionClose
 */
export const EventQueuePositionClose = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.EventQueuePositionClose",
  () => [
    { no: 1, name: "position_id", kind: "message", T: PositionId },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.EventPositionWithdraw
 */
export const EventPositionWithdraw = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.EventPositionWithdraw",
  () => [
    { no: 1, name: "position_id", kind: "message", T: PositionId },
    { no: 2, name: "trading_pair", kind: "message", T: TradingPair },
    { no: 3, name: "reserves_1", kind: "message", T: Amount },
    { no: 4, name: "reserves_2", kind: "message", T: Amount },
    { no: 5, name: "sequence", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.EventPositionExecution
 */
export const EventPositionExecution = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.EventPositionExecution",
  () => [
    { no: 1, name: "position_id", kind: "message", T: PositionId },
    { no: 2, name: "trading_pair", kind: "message", T: TradingPair },
    { no: 3, name: "reserves_1", kind: "message", T: Amount },
    { no: 4, name: "reserves_2", kind: "message", T: Amount },
    { no: 5, name: "prev_reserves_1", kind: "message", T: Amount },
    { no: 6, name: "prev_reserves_2", kind: "message", T: Amount },
    { no: 7, name: "context", kind: "message", T: DirectedTradingPair },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.EventBatchSwap
 */
export const EventBatchSwap = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.EventBatchSwap",
  () => [
    { no: 1, name: "batch_swap_output_data", kind: "message", T: BatchSwapOutputData },
    { no: 2, name: "swap_execution_1_for_2", kind: "message", T: SwapExecution },
    { no: 3, name: "swap_execution_2_for_1", kind: "message", T: SwapExecution },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.EventArbExecution
 */
export const EventArbExecution = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.EventArbExecution",
  () => [
    { no: 1, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "swap_execution", kind: "message", T: SwapExecution },
  ],
);

/**
 * Indicates that value was added to the DEX.
 *
 * @generated from message penumbra.core.component.dex.v1.EventValueCircuitBreakerCredit
 */
export const EventValueCircuitBreakerCredit = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.EventValueCircuitBreakerCredit",
  () => [
    { no: 1, name: "asset_id", kind: "message", T: AssetId },
    { no: 2, name: "previous_balance", kind: "message", T: Amount },
    { no: 3, name: "new_balance", kind: "message", T: Amount },
  ],
);

/**
 * Indicates that value is leaving the DEX.
 *
 * @generated from message penumbra.core.component.dex.v1.EventValueCircuitBreakerDebit
 */
export const EventValueCircuitBreakerDebit = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.EventValueCircuitBreakerDebit",
  () => [
    { no: 1, name: "asset_id", kind: "message", T: AssetId },
    { no: 2, name: "previous_balance", kind: "message", T: Amount },
    { no: 3, name: "new_balance", kind: "message", T: Amount },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.DexParameters
 */
export const DexParameters = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.DexParameters",
  () => [
    { no: 1, name: "is_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "fixed_candidates", kind: "message", T: AssetId, repeated: true },
    { no: 3, name: "max_hops", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "max_positions_per_pair", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "max_execution_budget", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.GenesisContent
 */
export const GenesisContent = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.GenesisContent",
  () => [
    { no: 1, name: "dex_params", kind: "message", T: DexParameters },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.CandlestickData
 */
export const CandlestickData = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.CandlestickData",
  () => [
    { no: 1, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "close", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "high", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "low", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "direct_volume", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "swap_volume", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.CandlestickDataRequest
 */
export const CandlestickDataRequest = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.CandlestickDataRequest",
  () => [
    { no: 1, name: "pair", kind: "message", T: DirectedTradingPair },
    { no: 2, name: "limit", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "start_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.CandlestickDataResponse
 */
export const CandlestickDataResponse = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.CandlestickDataResponse",
  () => [
    { no: 1, name: "data", kind: "message", T: CandlestickData, repeated: true },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.CandlestickDataStreamRequest
 */
export const CandlestickDataStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.CandlestickDataStreamRequest",
  () => [
    { no: 1, name: "pair", kind: "message", T: DirectedTradingPair },
  ],
);

/**
 * @generated from message penumbra.core.component.dex.v1.CandlestickDataStreamResponse
 */
export const CandlestickDataStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.dex.v1.CandlestickDataStreamResponse",
  () => [
    { no: 1, name: "data", kind: "message", T: CandlestickData },
  ],
);

